<template>
  <div style="margin: 0 auto; position: relative">
    <div style="border: 1px solid #dddddd; border-bottom: none; background-color: #f5f7fa">
      <el-radio-group v-model="decision" style="margin: 5px 0 5px 1%">
        <el-radio :label="0">同意</el-radio>
        <el-radio :label="1">
          转交
          <el-select 
              v-if="decision === 1" 
              v-model="transferPerson" 
              placeholder="请选择" 
              clearable 
              style="width: 120px">
            <el-option v-for="item in transferPersons" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-radio>
        <el-radio :label="2">
          拒绝
          <el-select 
              v-if="decision === 2" 
              v-model="canUntreatedNodes" 
              placeholder="请选择" 
              clearable 
              style="width: 120px">
            <el-option v-for="item in canUntreatedNodeList" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-radio>
        <el-button style="margin-left: 50px" type="primary" @click="submit">审批</el-button>
      </el-radio-group>
    </div>
    <div style="border: 1px solid #dddddd; padding: 10px" class="vm-form">
      <table class="gridtable" style="width: 100%" cellspacing="0">
        <tr>
          <td style="width: 100px; text-align: center; background-color: #d1e6f5">审批意见</td>
          <td style="height: 60px">
            <el-input 
                v-model="suggestion" 
                style="width: 50%" 
                type="textarea" 
                autosize 
                class="tag"/>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ApprovalHeadForm",
    props: {
      billType: {
        type: String,
        required: true,
      },
      billId: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        transferPerson: "",
        transferPersons: [],
        canUntreatedNodes: "",
        canUntreatedNodeList: [],
        decision: 0,
        suggestion: "",
        approveInitial: {
          applicationVarVOS: [],
        },
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.$emit("loading-status", { loading: true });
        let params = {
          billType: this.billType,
          billId: this.billId,
          sequId: this.sequId,
        };
        this.$http.get("basic", "applications/approve", params).then((resp) => {
          this.$emit("loading-status", { loading: false });
          this.approveInitial = resp.data;
          // console.log(this.approveInitial);
          for (let item in this.approveInitial.transferPersons) {
            this.transferPersons.push({ value: item, label: this.approveInitial.transferPersons[item] });
          }
          for (let item in this.approveInitial.canUntreatedNodes) {
            if (this.approveInitial.canUntreatedNodes[item] === "=提交人=") {
              this.approveInitial.canUntreatedNodes[item] = "=提交人=";
            }
            this.canUntreatedNodeList.push({ value: item, label: this.approveInitial.canUntreatedNodes[item] });
          }
        });
      },
      submit() {
        if (this.decision === 1) {
          if (this.transferPerson === "" || this.transferPerson === null) {
            return this.$message.error("请选择转交人");
          }
          if (this.suggestion === "" || this.suggestion === null) {
            return this.$message.error("审批意见必须填写");
          }
        }
        if (this.decision === 2) {
          if (this.canUntreatedNodes === "" || this.canUntreatedNodes === null) {
            return this.$message.error("请选择拒绝理由");
          }
          if (this.suggestion === "" || this.suggestion === null) {
            return this.$message.error("审批意见必须填写");
          }
        }
        // 消息总线通知刷新待办销售订单列表
        this.$confirm("确定审批吗?", "提示", { type: "warning" }).then(() => {
          this.$emit("loading-status", { loading: true });
          if (this.billType === "1") {
            let params = {};
            if (this.decision === 0) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: "0;submitter",
              };
            } else if (this.decision === 1) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.transferPerson,
              };
            } else {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.canUntreatedNodes,
              };
            }
            this.$emit("sucess-save", params);
          }else if (this.billType === "3") {
            let params = {};
            if (this.decision === 0) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: "0;submitter",
              };
            } else if (this.decision === 1) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.transferPerson,
              };
            } else {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.canUntreatedNodes,
              };
            }
            this.$emit("sucess-save", params);
          } else if (this.billType === "6") {
            let params = {};
            if (this.decision === 0) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: "0;submitter",
              };
            } else if (this.decision === 1) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.transferPerson,
              };
            } else {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.canUntreatedNodes,
              };
            }
            this.$emit("sucess-save", params);
          } else if (this.billType === "40") {
            let params = {};
            if (this.decision === 0) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: "0;submitter",
              };
            } else if (this.decision === 1) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.transferPerson,
              };
            } else {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.canUntreatedNodes,
              };
            }
            this.$emit("sucess-save", params);
          } else if (this.billType === "13") {
            let params = {};
            if (this.decision === 0) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: "0;submitter",
              };
            } else if (this.decision === 1) {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.transferPerson,
              };
            } else {
              params = {
                actionType: this.decision,
                approveNote: this.suggestion,
                untreadedFlowId: this.canUntreatedNodes,
              };
            }
            this.$emit("sucess-save", params);
          }
          this.$emit("loading-status", { loading: false });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.vm-form {
  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 4px;
    border-style: solid;
    border-color: #dddddd;
  }
}
</style>
